module.exports = __webpack_public_path__ + "img/Time.33e01377.jpeg";